import React from 'react';
import { useSearch } from './hooks/Serach.hook';
import { useSelector } from 'react-redux';
import { isMexico } from '@/helpers/locationHelpers';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import SearchView from './views/SearchView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const SearchController = () => {
  const searchFormData = useSelector(state => state.searchFormData);
  const currencyData = useSelector(state => state.currency);
  const location = useSelector(state => state.location?.data);
  const lenguage = useSelector(state => state.lenguage?.lang);

  const isFromMexico = isMexico(location);

  const {
    isLoading,
    workspacesDataFromBackend,
    coordinatesForMapCenter,
    onClickMarkers,
    isSignInModalIsOpen,
    closeSignInModal,
    closeWarningModal,
    isWarningModalIsOpen,
    loginWithGoogleOAuth,
  } = useSearch(searchFormData, currencyData, isFromMexico);

  const handleGoogleLogin = async ({ email, googleToken }) => {
    return loginWithGoogleOAuth({ username: email, googleToken });
  };

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <>
      <FlexContainer className={'flex-column width100 d-hide'}>
        Hola
      </FlexContainer>

      <FlexContainer className={'flex-column width100 m-hide'}>
        <SearchView
          spacesDataFromBackend={workspacesDataFromBackend}
          lenguage={lenguage}
          currencyData={currencyData}
          isSignInModalIsOpen={isSignInModalIsOpen}
          closeSignInModal={closeSignInModal}
          closeWarningModal={closeWarningModal}
          isWarningModalIsOpen={isWarningModalIsOpen}
          onGoogleLogin={handleGoogleLogin}
          coordinatesForMapCenter={coordinatesForMapCenter}
          onClickMarkers={onClickMarkers}
        />
      </FlexContainer>
    </>
  );
};

export default SearchController;
